<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">WorkOrder Search
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<form [formGroup]="workOderSearchForm">
  <ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
  <div class="mat-typography inputsBorder" mat-dialog-content>
    <div class="row">
      <div class="col-md-12 toggleBtn">
        <mat-slide-toggle class="tp-margin" (change)="advanceSearch($event)">
          ADVANCED SEARCH
        </mat-slide-toggle>
      </div>
      <div class="col-md-6 col-lg-4">
        <mat-form-field>
          <input type="text" formControlName="woNumber" placeholder="Search WO# (Enter at least 4 digits)" matInput>
        </mat-form-field>
      </div>
      <div class="col-md-6 col-lg-4">
        <mat-form-field>
          <input type="text" formControlName="externalAssetId" placeholder="Search External Asset Id" matInput>
        </mat-form-field>
      </div>
      <div class="col-md-6 col-lg-4" *ngIf="advance_search">
        <mat-form-field>
          <input type="text" formControlName="referenceNumber" placeholder="Search Reference Number" matInput>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="advance_search">
      <div class="row">
        <div class="col-md-6 col-lg-3">
          <mat-form-field>
            <mat-label>Service Type</mat-label>
            <mat-select formControlName="serviceType" (selectionChange)="getSubServices($event)" matNativeControl>
              <mat-option></mat-option>
              <mat-option *ngFor="let service of serviceType;" value="{{service.VendorServiceTypeID}}">
                {{service.VendorServiceTypeName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6 col-lg-3">
          <mat-form-field>
            <mat-label>Sub Service</mat-label>
            <mat-select formControlName="subServiceType" panelClass="selectPanelWd" matNativeControl>
              <mat-option></mat-option>
              <mat-option *ngFor="let service of subServiceType;"
                value="{{service.VendorServiceToSubServiceMappingID}}">
                {{service.VendorSubServiceTypeName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6 col-lg-3">
          <mat-form-field>
            <mat-label>WO Status</mat-label>
            <mat-select formControlName="woStatus" matNativeControl>
              <mat-option></mat-option>
              <mat-option *ngFor="let status of woStatus;" value="{{status.CODlCodeKey}}">
                {{status.CODvc255Description}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6 col-lg-3">
          <mat-form-field>
            <input type="text" formControlName="poNumber" placeholder="PO Number" matInput>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-lg-3">
          <mat-form-field>
            <input matInput class="pickerPadding" formControlName="startDate" [matDatepicker]="startDate"
              (focus)="startDate.open()" placeholder="Start Date">
            <mat-datepicker-toggle matSuffix [for]="startDate" startView="year"></mat-datepicker-toggle>
            <mat-datepicker #startDate></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-6 col-lg-3">
          <mat-form-field>
            <input matInput class="pickerPadding" formControlName="endDate" [matDatepicker]="endDate"
              (focus)="endDate.open()" placeholder="End Date">
            <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
            <mat-datepicker #endDate></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-6 col-lg-3">
          <mat-form-field>
            <input matInput type="text" formControlName="vendorName" list="dataList" placeholder="Provider Name">
            <datalist id="dataList">
              <select>
                <option *ngFor="let v of vendorList.response" value="{{v.providerName}}"></option>
              </select>
            </datalist>
          </mat-form-field>
        </div>
        <div class="col-md-6 col-lg-3">
          <mat-form-field>
            <input type="text" formControlName="shipToName" placeholder="Ship To Name" matInput>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <mat-form-field>
            <input type="text" (keyup)="searchCity(breakdownCity)" [(ngModel)]="breakdownCity"
              placeholder="Breakdown City" [matAutocomplete]="auto" ng-pattern="/^[a-zA-Z]*$/"
              [ngModelOptions]="{standalone: true}" matInput>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" autoActiveFirstOption>
              <mat-option *ngFor="let city of bdCities" [value]="city.CTYvc255CityName">
                {{city.CTYvc255CityName}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="col-md-6 col-lg-4">
          <mat-form-field>
            <mat-label>Breakdown State</mat-label>
            <mat-select formControlName="breakdownState" matNativeControl>
              <mat-option></mat-option>
              <mat-option *ngFor="let state of bdStates;" value="{{state.stateKey}}">
                {{state.stateName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="col-md-12 p-0 border-top woTable" *ngIf="getWorkOrder">
  <div class="data-table-event-file" *ngIf="getWorkOrder.length > 0">
    <table id="accordion" class="table table-bordered table-fixed">
      <thead>
        <tr>
          <th align="center" scope="col">WO#</th>
          <th align="center" scope="col">RO#</th>
          <th align="center" scope="col">Truck #</th>
          <th align="center" scope="col">Trailer #</th>
          <!-- <th align="center" scope="col">Asset</th> -->
          <th align="center" scope="col">Status</th>
          <th align="center" scope="col">Service Type</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let wo of getWorkOrder">
          <td scope="col">{{wo.WONumber}}
            <button class="btn btn-default text-dark p-0 ml-1" (click)="viewDetails(wo.WONumber)"
              nbTooltip="View Details" nbTooltipPlacement="bottom">
              <h6><i class="fa fa-info-circle" aria-hidden="true"></i></h6>
            </button>
          </td>
          <td scope="col">{{wo.RONumber}}</td>
          <td scope="col">{{wo.TruckNumber}}</td>
          <td scope="col">{{wo.TrailerNumber}}</td>
          <!-- <td scope="col">{{wo.TSQExternalAssetId}}</td> -->
          <td scope="col">{{wo.StatusDesc}}</td>
          <td scope="col">{{wo.ServiceDesc}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="col-md-12 p-0 border-top" *ngIf="dataNotFound">
  <div class="alert alert-info">
    <strong>No records found.!</strong>
  </div>
</div>
<div class="col-md-12 border-top" align="end" mat-dialog-actions>
  <button class="btn btn-semi-round bgBlue pull-right" (click)="searchWorkOrder()"> Search WorkOrder </button>
  <button class="btn btn-semi-round bgBlue pull-right ml-2" (click)="getChangeEventStatus()"> Change Event Status
  </button>
</div>